import type { FC } from 'react';

import { DynamicPriceCardGasV2Rendering } from '@sitecore/types/DynamicPriceCardGasV2';

import { CurrentDynamicPriceCard } from './CurrentDynamicPriceCard';

const DynamicPriceCardGas: FC<DynamicPriceCardGasV2Rendering> = () => <CurrentDynamicPriceCard product={'gas'} />;

export default DynamicPriceCardGas;
